import * as React from "react";
import { BoostCheckStyle } from "./boost-check-style";
import classNames from "classnames";
import { BoostCode } from "common/boosts";

export interface BoostProps {
    name: string;
    price: string;
    color: string;
    sku: BoostCode;
}

interface Props extends BoostProps {
    value: boolean;
    onChange: (newValue: boolean) => void;
}

const BoostCheck: React.FunctionComponent<Props> = p => {
    const { name, value, color, price, onChange } = p;

    return (
        <BoostCheckStyle className={classNames(value && "enabled")} color={color} onClick={() => onChange(!value)}>
            <div className="check">
                <div className="thumb" />
            </div>
            <div className="details">
                <div className="name">{name}</div>
                <div className="price">{price}</div>
            </div>
        </BoostCheckStyle>
    );
};

export default BoostCheck;
